<template>
	<div class="ReClientCallList">
		<div class="d-flex">
			<div class="w-100" style="align-items: center;">
				<el-select
					class="w-100 select-primary"
					size="large"                
					placeholder="Выбрать звонок"
					v-model="call"
					@change="onSelect"
				>
					<el-option
						v-for="(el_opt, el_index) in selCalls"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"                    
					>
					</el-option>
				</el-select>
			</div>
			<a role="button" class="btn btn-success btn-icon btn-call ml-2 AAAA" :disabled="call===''"  :href="task_link"><i class="d-block tim-icons icon-double-right"></i></a>
			<!--a type="button" class="btn btn-success btn-icon btn-simple btn-call ml-2" :disabled="call===''"  @click="ScrollToTask()"><i class="d-block tim-icons icon-double-right"></i></a-->
			<!--a type="button" class="btn btn-success btn-icon btn-simple btn-call ml-2" :disabled="call===''"  @click="$GVO.Call(strPhjoneNo,'TASK',objTask.id)"><i class="d-block tim-ic ic-phone"></i></a-->
		</div>
	</div>
</template>

<script>
	// import { BaseRadio } from 'src/components/index';
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReClientCallList',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			// BaseRadio,
		},
		props: {
			masCalls: Array,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				call:'',
			}
		},
		computed: {
			selCalls: function(){
				let masRet = [];
				// {'value':0,'label':'asdasdasd'}
				for (let i = 0; i < this.masCalls.length; i++) {
					masRet.push({'value':i,'label':`Задача ID ${this.masCalls[i].task_id}. ${this.masCalls[i].task_name}`});
				}
				return masRet;
			},
			task_link: function(){
				let strRet = '#';
				if(typeof this.masCalls[this.call] != 'undefined'){
					strRet = '/data/tasks/id/'+this.masCalls[this.call].task_id;
				}
				return strRet;
			}
		},
		methods: {
			onSelect(){

			},
			ScrollToTask(){
				document.querySelector('#task_'+this.masCalls[this.call].task_id).scrollIntoView();
			}
		},
	}
</script>
<style scoped>
	.ReClientCallList .btn-call{margin-top: 0px; }
	/* .ReClientCallList  >>> [type=button], button {-webkit-appearance: initial!important;} */
	
</style>
